import { cx } from '@/utils/cx';
import styles from '@/styles/components/Spinner/style.scss';

/** A small spinning ring in the current text colour, e.g. as a Button icon while a request runs. Decorative. */
export function Spinner({ size = 16, className }: { size?: number; className?: string }) {
  return <span className={cx(styles.spinner, className)} style={{ width: size, height: size }} aria-hidden />;
}
